import axios from 'axios';

const httpGoodNewsService = axios.create({
    baseURL: process.env.REACT_APP_SQUIRREL_URL,
    headers: {
        token: process.env.REACT_APP_SQUIRREL_TOKEN,
    },
});

export default httpGoodNewsService;
